module.exports = __webpack_public_path__ + "static/blog-img12-82972d018de358e16e8863dccc5e7a69.jpg";